/* Preserve native scrolling and block only clicks following a moved/cancelled touch. */
(function (global) {
  'use strict';
  function createGestureGuard(threshold) {
    var gesture = null;
    var blockedUntil = 0;
    return {
      start: function (x, y, id, now) {
        gesture = { x: x, y: y, id: id, moved: false };
        blockedUntil = 0;
      },
      move: function (x, y, id) {
        if (!gesture || gesture.id !== id) return;
        if (Math.hypot(x - gesture.x, y - gesture.y) >= threshold) gesture.moved = true;
      },
      cancel: function (now) {
        gesture = null;
        blockedUntil = now + 800;
      },
      end: function (x, y, id, now) {
        if (!gesture || gesture.id !== id) return;
        this.move(x, y, id);
        if (gesture.moved) blockedUntil = now + 800;
        gesture = null;
      },
      blocksClick: function (detail, now) {
        // Keyboard activation and script-driven native theme buttons remain available.
        return detail !== 0 && ((gesture && gesture.moved) || now < blockedUntil);
      }
    };
  }
  if (typeof module === 'object' && module.exports) module.exports = { createGestureGuard: createGestureGuard };
  if (!global.document || global.carderiaTapGuardInstalled) return;
  global.carderiaTapGuardInstalled = true;
  var doc = global.document;
  var guard = createGestureGuard(10);
  var active = false;
  var origin = null;
  function productAt(target) { return target && target.closest ? target.closest('.product-collection') : null; }
  function begin(target, x, y, id) {
    origin = productAt(target);
    active = !!origin;
    // A deliberate new gesture clears any earlier cancellation, including on hybrid devices.
    guard.start(x, y, id, Date.now());
  }
  if (global.PointerEvent) {
    doc.addEventListener('pointerdown', function (e) {
      if (e.isPrimary === false) { if (active) guard.cancel(Date.now()); return; }
      begin(e.target, e.clientX, e.clientY, e.pointerId);
      if (e.pointerType !== 'touch' && e.pointerType !== 'pen') active = false;
    }, { capture: true, passive: true });
    doc.addEventListener('pointermove', function (e) {
      if (active) guard.move(e.clientX, e.clientY, e.pointerId);
    }, { capture: true, passive: true });
    doc.addEventListener('pointerup', function (e) {
      if (active) guard.end(e.clientX, e.clientY, e.pointerId, Date.now());
      active = false;
    }, { capture: true, passive: true });
    doc.addEventListener('pointercancel', function () {
      if (active) guard.cancel(Date.now());
      active = false;
    }, { capture: true, passive: true });
  } else {
    doc.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { if (active) guard.cancel(Date.now()); return; }
      var t = e.touches[0]; begin(e.target, t.clientX, t.clientY, t.identifier);
    }, { capture: true, passive: true });
    doc.addEventListener('touchmove', function (e) {
      if (active && e.touches.length === 1) { var t = e.touches[0]; guard.move(t.clientX, t.clientY, t.identifier); }
    }, { capture: true, passive: true });
    doc.addEventListener('touchend', function (e) {
      if (active && e.changedTouches.length) { var t = e.changedTouches[0]; guard.end(t.clientX, t.clientY, t.identifier, Date.now()); }
      active = false;
    }, { capture: true, passive: true });
    doc.addEventListener('touchcancel', function () { if (active) guard.cancel(Date.now()); active = false; }, { capture: true, passive: true });
  }
  doc.addEventListener('click', function (e) {
    if (origin && productAt(e.target) === origin && guard.blocksClick(e.detail, Date.now())) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
})(typeof window === 'undefined' ? globalThis : window);
